const WELDA_GROUP_LOGO =
  "https://perfionapipro.welda.be:4432/Perfion/file.aspx?id=8b46293a-c4be-47f9-99de-c5615884d7d1";
const WELDA_LOGO =
  "https://perfionapipro.welda.be:4432/Perfion/file.aspx?id=8b46293a-c4be-47f9-99de-c5615884d7d1";
const WELDA_MACHINERY_LOGO =
  "https://perfionapipro.welda.be:4432/Perfion/file.aspx?id=86e03130-8ec5-49d8-a675-c222188cb518";
const AW_TECH_LOGO =
  "https://perfionapipro.welda.be:4432/Perfion/file.aspx?id=2c9e5ccc-6b9d-486d-a1af-ad1cc4c35324";
const METANOX_LOGO =
  "https://perfionapipro.welda.be:4432/Perfion/file.aspx?id=d0fee18c-b7a9-44ea-a0ca-bd886f598fb5";

const LOGOS_BY_COMPANY_NAME = {
  WELDA_GROUP: WELDA_GROUP_LOGO,
  WELDA: WELDA_LOGO,
  WELDA_MACHINERY: WELDA_MACHINERY_LOGO,
  AW_TECH: AW_TECH_LOGO,
  METANOX: METANOX_LOGO,
};

const LOGOS_BY_DOSSIERNR = {
  0: WELDA_GROUP_LOGO,
  10: WELDA_LOGO,
  15: WELDA_MACHINERY_LOGO,
  70: AW_TECH_LOGO,
  20: METANOX_LOGO,
};

module.exports = { LOGOS_BY_COMPANY_NAME, LOGOS_BY_DOSSIERNR };
